import { motion } from "framer-motion";
import { STATS } from "../../lib/content";

export const Stats = () => (
  <section data-testid="stats" className="bg-primary text-primary-foreground py-20 md:py-28">
    <div className="mx-auto max-w-[1400px] px-6 md:px-10 grid grid-cols-2 md:grid-cols-4 gap-y-14 gap-x-6">
      {STATS.map((s, i) => (
        <motion.div
          key={s.label}
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, delay: i * 0.1 }}
          className="text-center md:text-left"
        >
          <div className="font-display text-6xl md:text-8xl font-light leading-none mb-3">{s.value}</div>
          <div className="label-eyebrow text-white/70">{s.label}</div>
        </motion.div>
      ))}
    </div>
  </section>
);
